<template>
  <el-form ref="artist" :model="socials">
    <el-row class="socials-wrapper">
      <el-col>
        <el-form-item label="Spotify" prop="spotify">
          <el-input type="text" v-model="socials.spotify" clearable />
        </el-form-item>
        <el-form-item label="Website" prop="website">
          <el-input type="text" v-model="socials.website" clearable />
        </el-form-item>
        <el-form-item label="YouTube channel" prop="youtube_channel">
          <el-input type="text" v-model="socials.youtube_channel" clearable />
        </el-form-item>
        <el-form-item label="Instagram" prop="instagram">
          <el-input type="text" v-model="socials.instagram" clearable />
        </el-form-item>
        <el-form-item label="Facebook" prop="facebook">
          <el-input type="text" v-model="socials.facebook" clearable />
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  computed: {
    ...mapState('newReleasesArtists', ['socials', 'artist_id'])
  },

  methods: {
    ...mapActions('newReleasesArtists', ['readSocials'])
  },

  created() {
    if (this.artist_id !== null)
      this.readSocials(this.artist_id)
  }
}
</script>
<style scoped lang="scss">
  .socials-wrapper {
    max-width: 600px;
    margin: 0 auto;
  }
</style>
